import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Mobilization } from "@/v2/types";

export default async function FindAllMobilization({
    limit,
    skip,
    search,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    filter?: Record<string, string>;
}): Promise<{ data: Mobilization[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/mobilizations",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...filter,
        },
    });

    return res.data;
}
